(() => {
  const root = document.querySelector('[data-gx-track-order]');
  if (!root || root.dataset.gxTrackReady === 'true') return;
  root.dataset.gxTrackReady = 'true';

  const form = root.querySelector('[data-gx-track-form]');
  const result = root.querySelector('[data-gx-track-result]');
  const submit = form.querySelector('[type="submit"]');
  let requestId = 0;
  const text = (name, fallback) => root.dataset[name] || fallback;
  const fill = (template, values) => template.replace(/__([A-Z]+)__/g, (match, key) => (key in values ? values[key] : match));

  function show(state, title, detail) {
    result.replaceChildren();
    result.hidden = false;
    result.dataset.state = state;
    const heading = document.createElement('strong');
    heading.textContent = title;
    result.append(heading);
    if (detail) {
      const paragraph = document.createElement('p');
      paragraph.textContent = detail;
      result.append(paragraph);
    }
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;

    const order = form.elements.order.value.trim();
    const email = form.elements.id.value.trim();
    const currentRequest = ++requestId;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    show('loading', text('textLoading', 'Buscando tu pedido…'));

    try {
      const response = await fetch('https://shp.track123.com/shopify/api/order/anonymous-query', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          source_type: 1,
          locale: root.dataset.locale || 'es',
          store_domain: root.dataset.storeDomain,
          select_type: 1,
          email,
          order_or_number: order
        })
      });
      if (!response.ok) throw new Error('Tracking service unavailable');
      const data = await response.json();
      if (currentRequest !== requestId) return;

      if (data.no_query_data || !data.order_number || data.order_number === '0') {
        show('error', text('textNotFoundTitle', 'No encontramos ese pedido'), text('textNotFoundDetail', 'Comprueba el número y el correo de confirmación y vuelve a intentarlo.'));
        return;
      }

      const packages = Array.isArray(data.order_packages) ? data.order_packages : [];
      const title = fill(text('textOrder', 'Pedido __NUMBER__'), { NUMBER: data.order_number });
      if (!packages.length) {
        show('success', title, text('textLocated', 'Pedido localizado. La información de envío aparecerá cuando esté disponible.'));
        return;
      }

      show('success', title, packages.length === 1 ? text('textOneShipment', 'Envío localizado.') : fill(text('textManyShipments', '__COUNT__ envíos localizados.'), { COUNT: packages.length }));
      packages.forEach((item, index) => {
        const status = item.transit_display_status || item.status || item.tracking_status;
        const tracking = item.tracking_no || item.tracking_number;
        const parts = [fill(text('textShipment', 'Envío __NUMBER__'), { NUMBER: index + 1 })];
        if (status) parts.push(String(status));
        if (tracking) parts.push(fill(text('textTracking', 'Seguimiento: __CODE__'), { CODE: tracking }));
        const paragraph = document.createElement('p');
        paragraph.textContent = parts.join(' · ');
        result.append(paragraph);
      });
    } catch (_) {
      if (currentRequest === requestId) {
        show('error', text('textErrorTitle', 'No hemos podido consultar el seguimiento'), text('textErrorDetail', 'Inténtalo de nuevo en unos minutos.'));
      }
    } finally {
      if (currentRequest === requestId) {
        submit.disabled = false;
        form.removeAttribute('aria-busy');
      }
    }
  });
})();
